export class NoteModel{
    ticketId:number;
    value:string;
    createdDate:Date;
    createdBy:number;
    createdByValue:string;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/note.model.ts